import { render, staticRenderFns } from "./RatioAnalysis.vue?vue&type=template&id=079d3a2a&scoped=true&"
import script from "./RatioAnalysis.vue?vue&type=script&lang=js&"
export * from "./RatioAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./RatioAnalysis.vue?vue&type=style&index=0&id=079d3a2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079d3a2a",
  null
  
)

export default component.exports